import{useState as e,useEffect as o}from"react";const r=()=>{const[r,t]=e();return o((()=>{window.AP&&window.AP.user.getLocale((e=>t(e.replace("_","-"))))}),[]),[r,t]};export{r as useAtlassianLocale};
